/**
 * Map service slug → bundled image (legacy assets imported by Vite)
 */
import koruma from "@/assets/legacy/koruma-guvenlik.jpg";
import zirhliArac from "@/assets/legacy/koruma-guvenlik.jpg"; // TODO: zırhlı araç görseli ile değiştir
import temizlik from "@/assets/legacy/genel-temizlik.jpg";
import tesis from "@/assets/legacy/tesis-yonetimi.jpg";
import ilaclama from "@/assets/legacy/ilaclama.jpg";
import elektronik from "@/assets/legacy/elektronik-guvenlik.jpg";
import about from "@/assets/legacy/about.webp";
import banner1 from "@/assets/legacy/banner1.webp";
import banner2 from "@/assets/legacy/banner2.webp";
import heroMonitoring from "@/assets/hero-monitoring.webp";
import heroCleaning from "@/assets/temizlik-hizmetleri.webp";
import heroCleaning768 from "@/assets/temizlik-hizmetleri-768.webp";
import heroCleaning1280 from "@/assets/temizlik-hizmetleri-1280.webp";
import heroOzelGuvenlik from "@/assets/ozel-guvenlik.webp";
import heroOzelGuvenlik768 from "@/assets/ozel-guvenlik-768.webp";
import heroOzelGuvenlik1280 from "@/assets/ozel-guvenlik-1280.webp";
import heroSlide1Monitoring from "@/assets/hero-slide-1-monitoring.webp";
import heroAtasehir from "@/assets/atasehir-guvenlik-hizmetleri-3.webp";
import heroAtasehir768 from "@/assets/atasehir-guvenlik-hizmetleri-3-768.webp";
import heroAtasehir1280 from "@/assets/atasehir-guvenlik-hizmetleri-3-1280.webp";
import hizmetAlanlari from "@/assets/legacy/hizmet-alanlarimiz.jpg";

const map: Record<string, string> = {
  "koruma-ve-guvenlik": koruma,
  "zirhli-arac-ve-tasima": zirhliArac,
  "genel-temizlik": temizlik,
  "tesis-yonetimi": tesis,
  "ilaclama": ilaclama,
  "elektronik-guvenlik-sistemleri": elektronik,
  "felsefemiz": about,
  "hizmet-alanlarimiz": hizmetAlanlari,
};

export function resolveImage(srcOrSlug?: string | null, slug?: string): string {
  if (slug && map[slug]) return map[slug];
  if (!srcOrSlug) return banner1;
  // Local placeholder paths from seed (e.g. "/src/assets/legacy/x.jpg") → use slug map
  if (srcOrSlug.startsWith("/src/assets/")) {
    const base = srcOrSlug.split("/").pop()?.replace(".jpg", "") ?? "";
    const found = Object.entries(map).find(([, v]) => v.includes(base));
    return found?.[1] ?? banner1;
  }
  return srcOrSlug;
}

export const banners = [heroOzelGuvenlik, heroCleaning];
export const bannerSrcSets = [
  `${heroOzelGuvenlik768} 768w, ${heroOzelGuvenlik1280} 1280w, ${heroOzelGuvenlik} 1440w`,
  `${heroCleaning768} 768w, ${heroCleaning1280} 1280w, ${heroCleaning} 1920w`,
];
export const heroSlides = [heroSlide1Monitoring, heroOzelGuvenlik, heroAtasehir, heroCleaning];
export const heroSlideSrcSets: (string | undefined)[] = [
  // slide 0 uses /public preload — handled inline in Index.tsx
  undefined,
  `${heroOzelGuvenlik768} 768w, ${heroOzelGuvenlik1280} 1280w, ${heroOzelGuvenlik} 1440w`,
  `${heroAtasehir768} 768w, ${heroAtasehir1280} 1280w, ${heroAtasehir} 1440w`,
  `${heroCleaning768} 768w, ${heroCleaning1280} 1280w, ${heroCleaning} 1920w`,
];
export const aboutImage = about;
